import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_4 = ["innerHTML"]

import {computed, onMounted, ref} from 'vue';
import BackButton from '@/components/button/BackButton.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import userContractService from '@/api/UserContract';
import ContractSignatureForm from '@/views/App/MyContracts/ContractSignatureForm.vue';

// isBsgSide: HR signs the BSG places, otherwise the external user signs his places (both draw the signature)

export default /*@__PURE__*/_defineComponent({
  __name: 'ContractDocumentView',
  props: {
    documentId: {},
    isBsgSide: { type: Boolean }
  },
  emits: ["back", "signed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const contractDocument = ref<any>(null);
const showSignatureModal = ref(false);
const signPosition = ref<number | null>(null);
const isSaving = ref(false);
const isLoading = ref(true);

const isSignedBySide = computed(() =>
    props.isBsgSide ? contractDocument.value?.signedByBsg : contractDocument.value?.signedByUser
);

async function loadDocument() {
  try {
    const {data} = await userContractService.getDocument(props.documentId);
    contractDocument.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isLoading.value = false;
  }
}

// Sign buttons are part of the backend HTML, so clicks are caught here (event delegation)
function handleDocumentClick(event: MouseEvent) {
  const button = (event.target as HTMLElement).closest<HTMLElement>('.contract-sign-button');
  if (!button || button.dataset.side !== (props.isBsgSide ? 'bsg' : 'user')) {
    return;
  }

  signPosition.value = Number(button.dataset.position);
  showSignatureModal.value = true;
}

async function signDocument(digitalSignature: string) {
  if (signPosition.value === null || isSaving.value) {
    return;
  }

  const signData = {position: signPosition.value, digitalSignature};

  isSaving.value = true;
  try {
    const {data} = props.isBsgSide
        ? await userContractService.signDocumentBsg(props.documentId, signData)
        : await userContractService.signDocument(props.documentId, signData);
    contractDocument.value = data.data;
    showSignatureModal.value = false;

    SuccessToast(isSignedBySide.value ? 'Dokument vollständig unterschrieben.' : 'Unterschrift gespeichert.');
    emit('signed', contractDocument.value);
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSaving.value = false;
  }
}

onMounted(loadDocument);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BackButton, {
        label: "Zurück zur Übersicht",
        "margin-bottom": 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
      }),
      (contractDocument.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", {
              class: _normalizeClass(["badge me-2", contractDocument.value.signedByUser ? 'text-bg-success' : 'text-bg-warning'])
            }, _toDisplayString(__props.isBsgSide ? 'Mitarbeiter' : 'Ihre Unterschriften') + ": " + _toDisplayString(contractDocument.value.signaturesByUser) + " / " + _toDisplayString(contractDocument.value.requiredSignaturesByUser), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", contractDocument.value.signedByBsg ? 'text-bg-success' : 'text-bg-warning'])
            }, " BSG: " + _toDisplayString(contractDocument.value.signaturesByBsg) + " / " + _toDisplayString(contractDocument.value.requiredSignaturesByBsg), 3)
          ]))
        : _createCommentVNode("", true)
    ]),
    (isLoading.value)
      ? (_openBlock(), _createBlock(Loader, { key: 0 }))
      : _createCommentVNode("", true),
    (contractDocument.value && !isSignedBySide.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Bitte lesen Sie das Dokument und unterschreiben Sie an allen mit „Unterschreiben“ markierten Stellen" + _toDisplayString(__props.isBsgSide ? ' für die BSG' : '') + ". ", 1))
      : _createCommentVNode("", true),
    (contractDocument.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "contract-document",
          innerHTML: contractDocument.value.html,
          onClick: handleDocumentClick
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      modelValue: showSignatureModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showSignatureModal).value = $event)),
      title: "Digitale Unterschrift",
      sizeModal: "modal-md",
      "hide-footer": true
    }, {
      default: _withCtx(() => [
        _createVNode(ContractSignatureForm, {
          "is-saving": isSaving.value,
          onSign: signDocument
        }, null, 8, ["is-saving"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})